export default __webpack_public_path__ + "static/media/petday3.ee260e07.jpeg";